import cn from 'clsx'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'

// Components
import { Button, IconNewCollection } from '@tracklib/kit'
import MiniCollection from 'components/sidebar/minicollection'

// Selectors
import { selectAll, ownCollectionsSelector } from 'selectors'
import { selectRequest } from 'modules/requests/selectors'

// Types
import { Collection, ApiRequest } from 'types'

import styles from './minicollectionlist.css'

type MiniCollectionListProps = {
  className?: string
  ownCollections: Array<Collection>
  fetchCollectionsRequest: ApiRequest
}

const MiniCollectionList = ({ ownCollections, fetchCollectionsRequest, className }: MiniCollectionListProps): JSX.Element => (
  <ul className={cn(styles.wrapper, className)}>
    {ownCollections
      .sort((a, b) => b.id - a.id)
      .map(c => (
        <MiniCollection key={c.id} id={c.id} title={c.title} />
      ))}
    {!fetchCollectionsRequest.isDone &&
      ownCollections.length === 0 &&
      Array.from(Array(5).keys()).map(x => <MiniCollection key={x} loading />)}
    <li className={styles.create}>
      <Button variant="transparent" to="collection" modal>
        <IconNewCollection />
        New collection
      </Button>
    </li>
  </ul>
)

const mapStateToProps = createSelector([selectAll, ownCollectionsSelector], (state, ownCollections) => {
  const { profileId } = state.auth
  const profile = state.entities.profiles[String(profileId)]
  return {
    ownCollections,
    fetchCollectionsRequest: selectRequest(state, 'FETCH_COLLECTIONS', `?owner=${profile?.user}`),
  }
})
export default connect(mapStateToProps)(MiniCollectionList)
